module.exports = __webpack_public_path__ + "img/sld_scb_10_t1_red.c966f508.svg";